"use strict";Object.defineProperty(exports, "__esModule", {value: true});


var _6P52IAFYcjs = require('./6P52IAFY.cjs');



var _UCZW3OGHcjs = require('./UCZW3OGH.cjs');


var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');

// src/select/select-context.tsx
var _react = require('react');
var ctx = _PTOCUU2Dcjs.createStoreContext.call(void 0, 
  [_6P52IAFYcjs.PopoverContextProvider, _UCZW3OGHcjs.CompositeContextProvider],
  [_6P52IAFYcjs.PopoverScopedContextProvider, _UCZW3OGHcjs.CompositeScopedContextProvider]
);
var useSelectContext = ctx.useContext;
var useSelectScopedContext = ctx.useScopedContext;
var useSelectProviderContext = ctx.useProviderContext;
var SelectContextProvider = ctx.ContextProvider;
var SelectScopedContextProvider = ctx.ScopedContextProvider;
var SelectItemCheckedContext = _react.createContext.call(void 0, false);
var SelectHeadingContext = _react.createContext.call(void 0, null);









exports.useSelectContext = useSelectContext; exports.useSelectScopedContext = useSelectScopedContext; exports.useSelectProviderContext = useSelectProviderContext; exports.SelectContextProvider = SelectContextProvider; exports.SelectScopedContextProvider = SelectScopedContextProvider; exports.SelectItemCheckedContext = SelectItemCheckedContext; exports.SelectHeadingContext = SelectHeadingContext;
